import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';
import { EventCentreDialogState } from '../event-centre-dialog.state';
import { filterItems } from '../function/filter-items.function';

import { ToggleItemExpand } from './toggle-item-expand.action';

export function toggleItemExpandReducer(
    state: EventCentreDialogState,
    action: PayloadAction<
        ActionType.NOTI__EC__TOGGLE_ITEM_EXPAND,
        ToggleItemExpand
    >,
): EventCentreDialogState {
    try {
        const nextItems = state.items.map((e) => {
            if (
                action.payload.items.find(
                    (i) => i.eventCentreItemId === e.eventCentreItemId,
                ) == null
            ) {
                return e;
            }
            return {
                ...e,
                expanded: !e.expanded,
            };
        });

        const nextFilt = filterItems({
            items: nextItems,
            categoryId: state.categoryId,
            filterOpts: state.filterOpts,
            categories: state.categories,
            orderBy: state.orderBy,
            retainAsUnreadForUnreadCategory: action.payload.items.map(
                (e) => e.eventCentreItemId,
            ),
        });

        return {
            ...state,
            items: nextItems,
            filteredItems: nextFilt,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
